import React from 'react';
import { MapPin, Calendar, Award, ExternalLink } from 'lucide-react';
import { universities } from '../data/mock';

const Universities = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-amber-50 to-orange-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">Partner Üniversiteler</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Çekya'nın en prestijli üniversiteleriyle çalışıyoruz. Size en uygun programı birlikte bulalım.
          </p>
        </div>
      </section>

      {/* Universities List */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            {universities.map((university) => (
              <div
                key={university.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={university.image}
                    alt={university.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{university.name}</h3>
                  
                  <div className="flex flex-wrap gap-4 mb-4 text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <MapPin size={16} className="text-amber-600" />
                      {university.city}
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar size={16} className="text-amber-600" />
                      Kuruluş: {university.founded}
                    </div>
                    <div className="flex items-center gap-1">
                      <Award size={16} className="text-amber-600" />
                      {university.ranking}
                    </div>
                  </div>

                  <p className="text-gray-600 mb-4">{university.description}</p>

                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Popüler Programlar:</h4>
                    <div className="flex flex-wrap gap-2">
                      {university.programs.map((program, idx) => (
                        <span
                          key={idx}
                          className="bg-amber-50 text-amber-700 px-3 py-1 rounded-full text-sm"
                        >
                          {program}
                        </span>
                      ))}
                    </div>
                  </div>

                  <button className="text-amber-600 font-semibold flex items-center gap-2 hover:gap-3 transition-all">
                    Detaylı Bilgi
                    <ExternalLink size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Study in Czech Republic */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Neden Çekya'da Eğitim?</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="text-amber-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Kaliteli Eğitim</h3>
              <p className="text-gray-600">Avrupa standartlarında, dünya çapında tanınan diploma</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-amber-600">€</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Uygun Maliyet</h3>
              <p className="text-gray-600">Çek dilinde programlar ücretsiz, yaşam maliyeti düşük</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="text-amber-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Merkezi Konum</h3>
              <p className="text-gray-600">Avrupa'nın kalbinde, kolay seyahat imkanı</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="text-amber-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Kariyer Fırsatları</h3>
              <p className="text-gray-600">Güçlü ekonomi, iş bulma imkanları</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Universities;